import React from "react";
import { Button, Form, FormGroup } from "reactstrap";
import TextInput from "../Shared/Forms/TextInput";
import TextArea from "../Shared/Forms/TextArea";
import SelectInput from "../Shared/Forms/SelectInput";
import DatePicker from "../Shared/Forms/DatePicker";

export function RequestForm(props) {
  const {
    handleInputChange,
    handleDateInputChange,
    handleCheckboxInputChange,
    handleFormSubmit,
    updateUserInput,
    userInput
  } = props;
  const {
    contactName,
    due,
    description,
    eventName,
    email,
    locationAddress,
    locationCity,
    locationName,
    locationState,
    locationZip,
    organization,
    phone,
    squadMembers,
    termsAgreed
  } = userInput;

  const { costume, live, cheer, crockett } = squadMembers;

  function formIsValid(userInput) {
    const userInputKeys = Object.keys(userInput);
    const invalidException = {};
    const doNotValidate = ["due", "squadMembers", "type"];

    // Looping through everything here, because everything is required.
    // 'Breaking' (by throwing an exception because we can't do that with 'forEach') on the first invalid piece of state.
    try {
      userInputKeys.forEach(key => {
        console.log(key);
        if (!userInput[key].isValid && doNotValidate.indexOf(key) === -1) {
          throw invalidException;
        }
      });
      return true;
    } catch (err) {
      if (err !== invalidException) {
        throw err;
      }
      return false;
    }
  }

  return (
    <Form onSubmit={handleFormSubmit} className="container-fluid">
      <TextInput
        stateKey="organization"
        labelText="Organization"
        userInput={organization}
        placeholder="Your organization's name"
        invalidMessage="Please enter your organization's name"
        onChange={handleInputChange}
      />
      <TextInput
        stateKey="contactName"
        labelText="Contact Name"
        userInput={contactName}
        placeholder="Your name"
        invalidMessage="Please enter a contact name"
        onChange={handleInputChange}
      />
      <TextInput
        stateKey="phone"
        labelText="Contact Phone"
        placeholder="865-123-4567"
        userInput={phone}
        invalidMessage="Please enter a valid phone number"
        onChange={handleInputChange}
      />
      <TextInput
        stateKey="email"
        labelText="Contact Email"
        placeholder="name@example.com"
        userInput={email}
        invalidMessage="Please enter a valid email address"
        onChange={handleInputChange}
      />
      <TextArea
        userInput={description}
        labelText="Appearance Details"
        stateKey="description"
        placeholder="REQUIRED: Please provide details about your request, including what you would like our Spirit Team members to do during their appearance"
        invalidMessage="Please give us some details about your request"
        rows={6}
        onChange={handleInputChange}
      >
        <p>
          To help us evaluate your your request, please give us an overview of
          your event and what you would like our Spirit Team members to do
          during their apperance.
        </p>
      </TextArea>

      <h6>Team members requested:</h6>
      <div className="px-4 mt-2 mb-4">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            name="costume"
            checked={costume}
            onChange={event => {
              const { name } = event.target;
              handleCheckboxInputChange("squadMembers", name);
            }}
          />
          <label htmlFor="costume" className="form-check-label">
            Smokey (costume mascot)
          </label>
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            name="live"
            checked={live}
            onChange={event => {
              const { name } = event.target;
              handleCheckboxInputChange("squadMembers", name);
            }}
          />
          <label htmlFor="live" className="form-check-label">
            Smokey X (live mascot w/ handlers)
          </label>
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            name="cheer"
            checked={cheer}
            onChange={event => {
              const { name } = event.target;
              handleCheckboxInputChange("squadMembers", name);
            }}
          />
          <label htmlFor="cheer" className="form-check-label">
            Cheer / Dance Team
          </label>
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            name="crockett"
            checked={crockett}
            onChange={event => {
              const { name } = event.target;
              handleCheckboxInputChange("squadMembers", name);
            }}
          />
          <label htmlFor="crockett" className="form-check-label">
            Davy Crockett
          </label>
        </div>
      </div>

      <FormGroup row>
        <label className="col-12">Appearance Date / Time</label>
        <DatePicker
          name="due"
          value={due.val}
          onChange={handleDateInputChange}
          daysNoticeNeeded={14}
          warningText="Appearance requests made within 14 days of an event may be considered but are unlikely to be approved due to scheduling for games, practices, and appearances already being finalized."
        />
      </FormGroup>

      <SelectInput
        labelText="Appearance Type"
        stateKey="type"
        userInput={userInput}
        onChange={handleInputChange}
      >
        <option disabled defaultValue>
          --Choose from below --
        </option>
        <option value="business">Business/Corporate</option>
        <option value="media">Media</option>
        <option value="nonprofit">Non-Profit</option>
        <option value="ut">University department/college</option>
        <option value="utad">UT Athletics</option>
        <option value="personal">Personal</option>
      </SelectInput>

      <TextInput
        stateKey="eventName"
        labelText="Event Name"
        userInput={eventName}
        placeholder="ie: Vol Village"
        invalidMessage="Please enter an event name"
        onChange={handleInputChange}
      />
      <TextInput
        stateKey="locationName"
        labelText="Event Location"
        userInput={locationName}
        placeholder="ie: Circle Park, Sequoyah Hills Kroger"
        invalidMessage="Please enter an event location"
        onChange={handleInputChange}
      />
      <TextInput
        stateKey="locationAddress"
        labelText="Address"
        userInput={locationAddress}
        placeholder="1551 Lake Loudoun Blvd"
        invalidMessage="Please enter an address"
        onChange={handleInputChange}
      />
      <TextInput
        stateKey="locationCity"
        labelText="City"
        userInput={locationCity}
        placeholder="Knoxville"
        invalidMessage="Please enter a city"
        onChange={handleInputChange}
      />
      <TextInput
        stateKey="locationState"
        labelText="State"
        userInput={locationState}
        placeholder="TN"
        invalidMessage="Please enter a state"
        onChange={handleInputChange}
      />
      <TextInput
        stateKey="locationZip"
        labelText="Zip Code"
        userInput={locationZip}
        placeholder="37996"
        invalidMessage="Please enter a zip code"
        onChange={handleInputChange}
      />
      <div className="px-4 mt-2 mb-4">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            name="terms"
            checked={termsAgreed.val}
            onChange={event => {
              updateUserInput("termsAgreed", !termsAgreed.val);
            }}
          />
          <label htmlFor="termsAgreed" className="form-check-label">
            <strong>REQUIRED: </strong> I agree to the fees and policies as
            outlined in the{" "}
            <a
              href="https://utsports.com/sports/2018/9/28/cheer-dance-mascots-appearance-requests.aspx"
              target="blank"
            >
              UT Spirit Appearance Policies
            </a>.
          </label>
        </div>
      </div>
      <Button
        disabled={!formIsValid(userInput)}
        color="primary"
        size="lg"
        type="submit"
      >
        Submit
      </Button>
    </Form>
  );
}



// WEBPACK FOOTER //
// ./src/Spirit/RequestForm.jsx